<template>
  <v-card class="mx-auto mt-n3">
    <v-img
      :src="`${this.url}${data?.banners?.[0]?.web}`"
      class="my-3"
      contain
    />
    <v-card-title
      class="justify-center text-uppercase page-title"
      :class="{ 'page-titleSm': $vuetify.breakpoint.smAndDown }"
    >
      {{ data.parent?.title }}
    </v-card-title>
    <v-card-subtitle
      class="text-center page-sub-title"
      :class="{ 'page-subtitleSm': $vuetify.breakpoint.smAndDown }"
    >
      <h1 :class="$vuetify.breakpoint.smAndDown ? 'mt-5' : 'mt-0'">
        {{ data.title }}
      </h1>
    </v-card-subtitle>
    <v-container>
      <v-card-subtitle
        class="text-center page-sub-title text--primary"
        :class="{ 'page-subtitleSm': $vuetify.breakpoint.smAndDown }"
      >
        {{ data.description }}
      </v-card-subtitle>

      <div v-for="(content, i) in data.contents" :key="i">
        <v-row
          v-scrollanimation
          justify="center"
          :class="{ charmSmall: $vuetify.breakpoint.smAndDown }"
          class="mb-5"
        >
          <v-col
            cols="12"
            sm="6"
            md="6"
            :class="`${
              renderContentAlignment(content.images, 'left')
                ? 'order-2'
                : 'order-1'
            }`"
          >
            <v-card
              class="mx-auto"
              flat
              :class="$vuetify.breakpoint.smAndDown ? 'pl-3' : ' pl-0'"
            >
              <v-card-title class="text-h5 font-weight-bold mt-15">
                {{ content.title }}
              </v-card-title>
              <v-card-text>
                <div class="text--primary" v-html="content.description"></div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  block
                  rounded
                  dark
                  class="gradient-button"
                  v-if="renderActionButton(content.buttons)"
                  @click="
                    onHandleAction(renderActionButton(content.buttons).url)
                  "
                >
                  {{ renderActionButton(content.buttons).name }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="6"
            :class="`${
              renderContentAlignment(content.images, 'left')
                ? 'order-1'
                : 'order-2'
            }`"
          >
            <v-hover>
              <div
                slot-scope="{ hover }"
                :class="`${hover ? 'imgover' : 'imgleave'}`"
              >
                <v-img
                  class="rounded-xl"
                  :src="`${
                    content?.images?.[0]?.web?.url
                      ? `${url}${content?.images?.[0]?.web?.url}`
                      : ''
                  }`"
                  :width="$vuetify.breakpoint.smAndDown ? '100%' : '80%'"
                  :class="$vuetify.breakpoint.smAndDown ? 'ml-0' : 'ml-10'"
                ></v-img>
              </div>
            </v-hover>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-card>
</template>
<script>
import config from "../../config";
export default {
  name: "Template-9",
  props: ["data"],
  data() {
    return {
      url: config.airport.url,
    };
  },
  methods: {
    renderActionButton(buttons = []) {
      if (buttons.length) {
        let services = buttons[0].services;
        let outside = services.find((item) => item.type === "outside");
        if (outside) {
          return {
            name: buttons[0].name,
            url: outside.link,
          };
        }
      } else return null;
    },
    onHandleAction(url) {
      window.open(url, "_blank");
    },
    renderContentAlignment(content = [], alignment) {
      if (content.length) {
        return content[0].web.placement == alignment ? true : false;
      } else return false;
    },
  },
  mounted() {},
};
</script>
